<template>
  <a-sub-menu
    :key="menuInfo.Name"
    v-bind="$props"
    v-on="$listeners"
    @titleClick="OnTitleClick"
  >
    <!--表单模块描述-->
    <span class="cg-sub-menu-title" slot="title">
      <img class="cg-sub-menu-title-icon anticon anticon-appstore" v-if="level == 1 && IconPath" :src="IconPath" />
      <a-icon v-else-if="level == 1" type="appstore" style="font-size: 16px" />
      <a-badge :count="MsgCount" :number-style="msgCountStyle">
        <span style="padding-right:20px;">
          {{ menuInfo.Desc }}
        </span>
      </a-badge>
    </span>
    <template v-for="item in menuInfo.Children">
      <!--表单描述-->
      <a-menu-item v-if="!item.Children" :key="item.Name">
        <a-badge :count="MenuMsgCountCache[item.UserFormKey] || 0" 
          :number-style="msgCountStyle">
          <span style="margin-left:3px; padding-right:20px;">
            {{ item.Desc }}
            <a-icon v-if="item.FormUrl" type="link" />
          </span>
        </a-badge>
      </a-menu-item>
      <sub-menu v-else
        @subMenuClick="OnTitleClick"
        :key="item.Name"
        :menu-info="item"
        :level="level + 1"
        :selectedMenuKeys="selectedMenuKeys"
      />
    </template>
  </a-sub-menu>
</template>

<script>
const IconCache = {};

import { Menu } from "ant-design-vue";

export default {
  name: "SubMenu",
  isSubMenu: true,
  props: {
    ...Menu.SubMenu.props,
    selectedMenuKeys: {
      type: Array,
      default: () => [],
    },
    menuInfo: {
      type: Object,
      default: () => ({}),
    },
    level: {
      type: Number,
      default: 0,
    },
    msgCountStyle: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      IconPath: ""
    };
  },
  computed: {
    IsSelected() {
      return this.selectedMenuKeys.includes(this.menuInfo?.Name);
    },
    MenuMsgCountCache() {
      return this.$store.state.MenuMsgCountCache;
    },
    MsgCount() {

      let _count = 0;

      let _list = this.menuInfo.Children.concat([]);

      for(let _i=0; _i<_list.length; _i++) {

        let _item = _list[_i];

        if(_item.UserFormKey) {
          _count += (this.MenuMsgCountCache[_item.UserFormKey] || 0);
        }

        if(_item.Children) {
          _list = _list.concat(_item.Children);
        }
      }

      return _count;
    }
  },
  created() {

    //存在icon
    if(this.menuInfo.ModuleIcon) {

      //缓存不存在
      if (IconCache[this.menuInfo.ModuleIcon] === undefined) {

        var _path = CmnMis.Func.AddSiteRoot(this.menuInfo.ModuleIcon);

        var _img = new Image();

        _img.onload = () => {
          this.IconPath = _path;
          IconCache[this.menuInfo.ModuleIcon] = _path;
        };

        _img.onerror = () => {
          this.IconPath = "";
          IconCache[this.menuInfo.ModuleIcon] = "";
        };

        _img.src = _path;
      } else {
        this.IconPath = IconCache[this.menuInfo.ModuleIcon];
      }
    }
  },
  methods: {
    AddSiteRoot(path) {
      return CmnMis.Func.AddSiteRoot(path);
    },
    OnTitleClick({ key, domEvent }) {
      this.$emit("subMenuClick", { key, domEvent });
    }
  },
};
</script>
<style>
.cg-sub-menu-title {
  line-height: 18px;
  display: inline-block;
}

.anticon.anticon-appstore.cg-sub-menu-title-icon {
  margin-right: 10px;
  width: 18px;
  vertical-align: text-bottom;
}
</style>
